import React from 'react'
import styled from 'styled-components'
import { device } from './Breakpoints'
import iconPhone from '../icons/icon-phone.svg'

const Container = styled.section`
  padding: 40px 0 30px;
  display: block;
  @media ${device.mobileL} {
    padding: 40px;
  }
  .inner {
    display: flex;
    text-justify: top;
    margin: 0 20px 0 -60px;
    @media ${device.tablet} {
      flex-direction: column;
      width: 100%;
      margin-left: 0;
    }
    h3 {
      text-justify: top;
      display: block;
      margin: 0;
      color: #148581;
      margin-left: 20px;
      @media ${device.mobileL} {
        font-size: 1.2em;
        margin-left: 0px;
      }
    }
    img {
      @media ${device.tablet} {
        margin-left: 0%;
        margin-bottom: 3%;
      }
    }
  }
  a {
    color: #8ccbb6;
    font-size: 1.5em;
    text-decoration: none;
    display: block;
    margin-bottom: 10px;
    @media ${device.mobileL} {
      font-size: 1.8em;
    }
  }
  p {
    font-family: 'Santral Light', Arial, Helvetica, sans-serif;
  }
`
const AlignCenter = styled.div`
  max-width: 960px;
  margin: auto;

  @media ${device.mobileL} {
    max-width: 100%;
    flex-wrap: wrap;
    text-align: center;
  }
`

const CentralAtendimento = () => (
  <Container>
    <AlignCenter>
      <div className="inner">
        <img src={iconPhone} alt="Telefone" />
        <h3>Central de Atendimento</h3>
      </div>
      <a href="tel:(11)5080-6370"> (11)5080-6370</a>
      <p>
        2ª a 6ª feira, das 08h às 20h
        <br />
        Sábado das 08h às 12h
      </p>
    </AlignCenter>
  </Container>
)

export default CentralAtendimento
